export enum SignupSource {
    NEWSLETTER = 0,
    VENUEMEMBERSHIP = 1,
    OFFERCLAIM = 2,
}
